import React, { Suspense, lazy, useState, useEffect, useContext } from 'react';
import { BrowserRouter, Switch, Route, Redirect, useLocation } from 'react-router-dom';
import '../node_modules/bootstrap/dist/css/bootstrap.min.css';
import '../node_modules/bootstrap/dist/js/bootstrap.bundle';
import Navbar from './components/Navbar';
import Footer from './components/Footer/Footer';
import Subscription from './components/Subscription';
import Serial from './components/LanguageData.jsx';
import VideoPlayer from './components/VideoPlayer';
import Download from './components/Download';
import LanguageData from './components/LanguageData';
import './App.css?version=2.2';
import FooterLink from './components/Footer/FooterLink';
import NewLogin from './components/NewLogin';
import ReactPlay from './components/ReactPlay';
import ScrollToTop from './components/ScrollToTop';
import { Contextone } from './components/Context';
import Profile from './components/Profile';
import Search from './components/Search';
import './components/css/responsive.css';
import globalSetting from "./configuration.js";
import Cookies from 'js-cookie';
import Screen from './components/screen.jsx';
import News from './components/News.jsx';
import NewsNavbar from './components/NewsNavbar.jsx';
import NewsSearch from './components/NewsSearch.jsx';
import LivePlayer from './components/LivePlayer.jsx';
import Support from './components/Support.jsx';

const Home = lazy(() => import('./components/Home'));
const Detail = lazy(() => import('./components/Detail'));
const Rent = lazy(() => import('./components/Rent'));
const ExtraVid = lazy(() => import('./components/ExtraDetail'));
const View = lazy(() => import('./components/View'));
const Cast = lazy(() => import('./components/Cast'));
const host = window.location.host;

function App() {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [isUrl, setUrl] = useState([]);
  const counterContext = useContext(Contextone);
  const [loading, setLoading] = useState();
  const [showScreen, setShowScreen] = useState(() => {
    let savedShowScreen = localStorage.getItem('showScreen');
    if (
      window.location.pathname.includes('/Search') ||
      window.location.pathname.includes('/Subscription') ||
      window.location.pathname.includes('/Rented') ||
      window.location.pathname.includes('/Movies') ||
      window.location.pathname.includes('/Music') ||
      window.location.pathname.includes('/Tvshows') ||
      window.location.pathname.includes('/videodetails')) {
      savedShowScreen = false;
    }
    return savedShowScreen !== null ? JSON.parse(savedShowScreen) : true;
  });

  useEffect(() => {
    const fetchGetDomain = async () => {
      try {
        counterContext.setLogo('')
        counterContext.setTitle('')
        setLoading(true)
        const response = await fetch('https://launch.ottsnap.com/api/get-domain', {
          method: 'POST',
          body: JSON.stringify({ "domain": host}),
          headers: {
            'Content-type': 'application/json; charset=UTF-8',
          }
        });
        const data = await response.json();
        setUrl(data.data)
        // Cookies.set('url', data.data.domain);
        counterContext.setDomain(data.data.domain)
        // counterContext.setgoogleVerificationCode(data.data.google_site_verification)
        counterContext.setLogo(data.data.logo)
        counterContext.setNavbarTitle(data.data.title)
        counterContext.setTitle(data.data.title)
        setLoading(false)
      } catch (error) {
        console.error('Error:', error);
      }
    };
    fetchGetDomain();
  }, []);


  useEffect(() => {
    const faviconUrl = counterContext.isLogo;
    const clientname = counterContext.isTitle;
    const link = document.getElementById('dynamic-favicon');
    const title = document.getElementById('dynamic-title');
    const dynamicTouchIcon = document.getElementById('dynamic-touch-icon');
    if (link) {
      link.href = faviconUrl;
    }
    if (dynamicTouchIcon) {
      dynamicTouchIcon.href = faviconUrl;
    }
    if (title) {
      title.textContent = clientname;
    }
    document.title = clientname;
  }, [counterContext.isTitle]);

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  // if ( counterContext.isDomain !== "shrissstudio.ottsnap.in" &&  windowWidth < 768) {
  //   return <div> <Download /> </div>;
  // }

  const handleShowContent = (type) => {
    if (type === 'Entertainment') {
      setShowScreen(false);
      localStorage.setItem('showScreen', false);
      counterContext.setShowNewsContent(false);
    } else if (type === 'News') {
      setShowScreen(false);
      localStorage.setItem('showScreen', false);
      counterContext.setShowNewsContent(true);
    }
  };
  return (
    <BrowserRouter>
      {/* <Helmet>
        <meta name="google-site-verification" content={counterContext.googleVerificationCode} />
      </Helmet> */}
      {counterContext.isDomain && (
        <div className="app-container">
          {counterContext.isDomain === 'mahuaplay.ottsnap.in' ? (
            showScreen ? (
              <Screen handleShowContent={handleShowContent} />
            ) : (
              counterContext.showNewsContent ? (
                <NewsContent />
              ) : (
                <AppContent />
              )
            )
          ) : (
            <>
              <AppContent />
              <ScrollToTop />
            </>
          )}
          <ScrollToTop />
        </div>
      )}
    </BrowserRouter>
  );
}

export function NewsContent() {
  const location = useLocation();
  const uid = Cookies.get('userid');

  const isLoginPage = location.pathname === '/NewLogin';
  const isReactPlayer = location.pathname.startsWith('/play');
  const isVideoPlayer = location.pathname === '/player';
  const isLivePlayer = location.pathname.startsWith('/live');
  const isSupport = location.pathname.startsWith('/Support');

  useEffect(() => {
    const handleBeforeUnload = () => {
      sessionStorage.setItem('scrollPosition', window.scrollY);
    };

    window.addEventListener('beforeunload', handleBeforeUnload);
  }, []);

  useEffect(() => {
    const scrollPosition = sessionStorage.getItem('scrollPosition');
    if (scrollPosition) {
      window.scrollTo(0, parseInt(scrollPosition));
    }
  }, []);

  if (uid && isLoginPage) {
    return <Redirect to="/" />
  }

  return (
    <>
      {!isLoginPage && !isVideoPlayer && !isReactPlayer && !isLivePlayer && <NewsNavbar />}
      <div className="content">
        <Suspense fallback={<></>}>
          <Switch>
            <Route exact path="/" component={News} />
            <Route path="/Support/:page_name" component={Support} />
            <Route exact path="/ExtraDetail" component={ExtraVid} />
            <Route exact path="/LanguageData/:lid" component={LanguageData} />
            <Route exact path="/NewLogin" component={NewLogin} />
            <Route exact path="/NewsSearch/:name" component={NewsSearch} />
            <Route path="/play/:moviename/:encoded" component={ReactPlay} />
            <Route exact path="/Player/:moviename/:encoded" component={VideoPlayer} />
            <Route exact path="/live/:id/:type_id/:video_type/:upcoming_type" component={LivePlayer} />
            <Route exact path="/Profile" component={Profile} />
            <Route exact path="/View/:type/:title/:id" component={View} />
            <Route exact path="/Cast" component={Cast} />
            <Route exact path="/:page_name" component={FooterLink} />
            <Route path="/:isurl/:moviename/:encoded" component={Detail} />
            <Redirect to="/" />
          </Switch>
        </Suspense>
      </div>
      {!isLoginPage && !isReactPlayer && !isVideoPlayer && !isLivePlayer && !isSupport && <Footer />}
    </>
  );

}

export function AppContent() {
  const location = useLocation();
  const uid = Cookies.get('userid');

  const isLoginPage = location.pathname === '/NewLogin';
  const isSubscribePage = location.pathname === '/Subscription';
  const isReactPlayer = location.pathname.startsWith('/play');
  const isVideoPlayer = location.pathname === '/player';
  const isLivePlayer = location.pathname.startsWith('/live');
  const isSupport = location.pathname.startsWith('/Support');

  useEffect(() => {
    const handleBeforeUnload = () => {
      sessionStorage.setItem('scrollPosition', window.scrollY);
    };

    window.addEventListener('beforeunload', handleBeforeUnload);
  }, []);

  useEffect(() => {
    const scrollPosition = sessionStorage.getItem('scrollPosition');
    if (scrollPosition) {
      window.scrollTo(0, parseInt(scrollPosition));
    }
  }, []);

  if (uid && isLoginPage) {
    return <Redirect to="/" />
  }

  return (
    <>
      {!isLoginPage && !isSubscribePage && !isVideoPlayer && !isLivePlayer && !isReactPlayer && !isSupport && <Navbar />}
      
      <div className="content">
        <Suspense fallback={<></>}>
          <Switch>
            <Route exact path="/" component={Home} />
            <Route exact path="/Rented" component={Rent} />
            <Route path="/Support/:page_name" component={Support} />
            <Route exact path="/browse/:title/:movie/:id" component={ExtraVid} />
            <Route exact path="/Subscription" component={Subscription} />
            <Route exact path="/LanguageData/:lid" component={LanguageData} />
            <Route exact path="/Search/:name" component={Search} />
            <Route exact path="/Player/:moviename/:encoded" component={VideoPlayer} />
            <Route exact path="/live/:id/:type_id/:video_type/:upcoming_type" component={LivePlayer} />
            <Route exact path="/NewLogin" component={NewLogin} />
            <Route path="/play/:moviename/:encoded" component={ReactPlay} />
            <Route exact path="/Profile" component={Profile} />
            <Route exact path="/View/:type/:title/:id" component={View} />
            <Route exact path="/Cast" component={Cast} />
            <Route exact path="/:page_name" component={FooterLink} />
            <Route path="/:isurl/:moviename/:encoded" component={Detail} />

            <Route path="/:name/:id" component={Home} />
            <Redirect to="/" />
          </Switch>

        </Suspense>
      </div>
      {!isLoginPage && !isReactPlayer && !isVideoPlayer && !isLivePlayer && !isSubscribePage && !isSupport && < Footer />}
    </>
  );
}

export default App;
